export default __webpack_public_path__ + "static/media/KneeExtensionAtTerminalStance.279e2eef.png";